import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox, FormControlLabel } from '@mui/material';
import React, { useMemo } from 'react';
import { ECheckboxState } from '~/shared/types';
export function FormikCheckbox({ name, formikProps, ...props }) {
    const { handleChange, values } = formikProps;
    const isChecked = useMemo(() => {
        const [state] = values[name] || [];
        return state === ECheckboxState.on;
    }, [name, values]);
    return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { name: name, checked: isChecked, onChange: handleChange, ...props }), label: props.label, labelPlacement: 'start', sx: {
            '&.MuiFormControlLabel-root': {
                justifyContent: 'space-between',
                marginLeft: 0,
            },
        } }));
}
